class BBVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.buttonShowMoreOptionValuesMobile = this.querySelector('[data-option-show-mobile]');
    this.hiddenOptionValuesMobile = this.querySelectorAll('[data-option-value-hidden-mobile]');
    this.productHandle = this.dataset.productHandle;
  }

  handleShowMoreOptionValuesMobile() {
    this.hiddenOptionValuesMobile?.forEach((elm) => {
      elm.removeAttribute('data-option-value-hidden-mobile');
    });
    this.buttonShowMoreOptionValuesMobile?.remove();
    localStorage.setItem('bb-variant-picker-show-all-mobile', this.productHandle);
  }

  async connectedCallback() {
    if (localStorage.getItem('bb-variant-picker-show-all-mobile') === this.productHandle) {
      this.handleShowMoreOptionValuesMobile();
    }
    this.buttonShowMoreOptionValuesMobile?.addEventListener('click', async () => {
      this.handleShowMoreOptionValuesMobile();
    });
  }
}
if (!customElements.get('bb-variant-picker')) {
  customElements.define('bb-variant-picker', BBVariantPicker);
}

class BBCountDown extends HTMLElement {
  static get observedAttributes() {
    return ['data-expiration'];
  }

  constructor() {
    super();
    this.intervalId = null;
    this.expirationDate = null;
    this.hasNotifiedExpiry = false;
    this.unitElements = null;
  }

  connectedCallback() {
    this.setAttribute('role', this.getAttribute('role') || 'timer');
    this.setAttribute('aria-live', this.getAttribute('aria-live') || 'polite');
    this.cacheUnitElements();
    this.refreshExpiration();
    this.startTicker();
  }

  disconnectedCallback() {
    this.stopTicker();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-expiration' && oldValue !== newValue) {
      this.refreshExpiration();
    }
  }

  cacheUnitElements() {
    this.unitElements = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
  }

  refreshExpiration() {
    this.stopTicker();
    this.hasNotifiedExpiry = false;
    this.classList.remove('is-expired');
    this.expirationDate = this.parseExpiration(this.dataset.expiration);
    this.updateDisplay();
    this.startTicker();
  }

  parseExpiration(rawValue) {
    if (!rawValue || typeof rawValue !== 'string') {
      return null;
    }

    var trimmed = rawValue.trim();
    if (!trimmed) {
      return null;
    }

    var normalized = trimmed.replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      normalized = trimmed + 'T00:00';
    }
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
      normalized += ':00';
    }

    var candidate = new Date(normalized);
    return isNaN(candidate.getTime()) ? null : candidate;
  }

  startTicker() {
    if (!this.expirationDate) {
      return;
    }
    if (this.intervalId !== null) {
      return;
    }

    this.intervalId = window.setInterval(
      function () {
        this.updateDisplay();
      }.bind(this),
      1000,
    );
  }

  stopTicker() {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  updateDisplay() {
    var units = this.calculateRemaining();
    this.renderUnits(units);

    if (units.totalMilliseconds <= 0 && !this.hasNotifiedExpiry) {
      this.hasNotifiedExpiry = true;
      this.classList.add('is-expired');
      this.stopTicker();
    } else if (units.totalMilliseconds > 0) {
      this.classList.remove('is-expired');
    }
  }

  calculateRemaining() {
    if (!this.expirationDate) {
      return {
        days: '--',
        hours: '--',
        minutes: '--',
        seconds: '--',
        totalMilliseconds: -1,
      };
    }

    var now = new Date();
    var totalMilliseconds = this.expirationDate.getTime() - now.getTime();
    var remaining = Math.max(totalMilliseconds, 0);

    var totalSeconds = Math.floor(remaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
      totalMilliseconds: totalMilliseconds,
    };
  }

  renderUnits(units) {
    this.cacheUnitElements();

    this.updateUnit(this.unitElements.days, units.days, false);
    this.updateUnit(this.unitElements.hours, units.hours, true);
    this.updateUnit(this.unitElements.minutes, units.minutes, true);
    this.updateUnit(this.unitElements.seconds, units.seconds, true);
  }

  updateUnit(target, value, pad) {
    if (!target) {
      return;
    }
    var output = value;
    if (typeof value === 'number' && pad) {
      output = this.padNumber(value);
    }
    if (typeof value === 'number' && !pad) {
      output = String(value);
    }
    if (typeof value === 'string') {
      output = value;
    }
    if (target.textContent !== output) {
      target.textContent = output;
    }
  }

  padNumber(value) {
    return value < 10 ? '0' + value : String(value);
  }
}

if (!customElements.get('bb-countdown')) {
  customElements.define('bb-countdown', BBCountDown);
}

class MediaGridNewRatingVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('[data-media-grid-new-video]');
    this.playBtn = this.querySelector('[data-media-grid-new-play-btn]');
    this.thumb = this.querySelector('.media-grid-new-rating-video__thumbnail');

    if (!this.video) return;

    this._onPlay = this._updatePlayState.bind(this);
    this._onPause = this._updatePlayState.bind(this);
    this._onEnded = this._onVideoEnded.bind(this);

    this.video.addEventListener('play', this._onPlay);
    this.video.addEventListener('pause', this._onPause);
    this.video.addEventListener('ended', this._onEnded);

    if (this.playBtn) {
      this._onPlayBtnClick = this._togglePlay.bind(this);
      this.playBtn.addEventListener('click', this._onPlayBtnClick);
    }

    if (!this.video.hasAttribute('controls')) {
      var mediaArea = this.querySelector('.media-grid-new-rating-video__media');
      if (mediaArea) {
        this._onMediaClick = function (e) {
          if (e.target.closest('[data-media-grid-new-play-btn]')) return;
          e.preventDefault();
          e.stopPropagation();
          this._togglePlay(e);
        }.bind(this);
        mediaArea.addEventListener('click', this._onMediaClick);
        this._mediaArea = mediaArea;
      }
    }

    this._updatePlayState();
  }

  disconnectedCallback() {
    if (this.video) {
      this.video.removeEventListener('play', this._onPlay);
      this.video.removeEventListener('pause', this._onPause);
      this.video.removeEventListener('ended', this._onEnded);
    }
    if (this.playBtn && this._onPlayBtnClick) {
      this.playBtn.removeEventListener('click', this._onPlayBtnClick);
    }
    if (this._mediaArea && this._onMediaClick) {
      this._mediaArea.removeEventListener('click', this._onMediaClick);
    }
  }

  _togglePlay(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  _updatePlayState() {
    if (!this.playBtn) return;
    if (this.video.paused) {
      this.playBtn.classList.remove('media-grid-new-rating-video__play-btn--hidden');
    } else {
      this.playBtn.classList.add('media-grid-new-rating-video__play-btn--hidden');
      if (this.thumb) this.thumb.classList.add('media-grid-new-rating-video__thumbnail--hidden');
    }
  }

  _onVideoEnded() {
    if (this.playBtn) this.playBtn.classList.remove('media-grid-new-rating-video__play-btn--hidden');
  }
}

if (!customElements.get('media-grid-new-rating-video')) {
  customElements.define('media-grid-new-rating-video', MediaGridNewRatingVideo);
}

class MediaGridNewCollapseWrapper extends HTMLElement {
  connectedCallback() {
    this.expandBtn = this.querySelector('[data-media-grid-new-expand]');
    if (!this.expandBtn) return;

    this._onExpand = this._expand.bind(this);
    this.expandBtn.addEventListener('click', this._onExpand);
  }

  disconnectedCallback() {
    if (this.expandBtn && this._onExpand) {
      this.expandBtn.removeEventListener('click', this._onExpand);
    }
  }

  _expand() {
    var fullHeight = this.scrollHeight;
    this.style.maxHeight = fullHeight + 'px';
    this.classList.add('media-grid-new-expanded');

    if (this.expandBtn) {
      this.expandBtn.setAttribute('aria-expanded', 'true');
      this.expandBtn.setAttribute('aria-hidden', 'true');
      this.expandBtn.style.opacity = '0';
      this.expandBtn.style.pointerEvents = 'none';
    }

    var gradient = this.querySelector('.media-grid-new-collapse-gradient');
    if (gradient) {
      gradient.setAttribute('aria-hidden', 'true');
      gradient.style.opacity = '0';
    }

    this._onTransitionEnd = function () {
      this.style.maxHeight = 'none';
      this.removeEventListener('transitionend', this._onTransitionEnd);
    }.bind(this);

    this.addEventListener('transitionend', this._onTransitionEnd);
  }
}

if (!customElements.get('media-grid-new-collapse-wrapper')) {
  customElements.define('media-grid-new-collapse-wrapper', MediaGridNewCollapseWrapper);
}

class BBBundle extends HTMLElement {
  connectedCallback() {
    this.data = this._parseData();
    if (!this.data) return;

    this.selectedVariant = String(this.dataset.defaultVariant || this.data.defaultVariant || '');
    this.savingsTemplate = this.dataset.savingsTemplate || '{amount}';

    this.toggles = Array.from(this.querySelectorAll('[data-fbt-toggle]'));
    this.addButtons = Array.from(this.querySelectorAll('[data-fbt-add]'));

    this.anchorImages = Array.from(this.querySelectorAll('[data-anchor-image]'));
    this.anchorPrices = Array.from(this.querySelectorAll('[data-anchor-price]'));
    this.totalEls = Array.from(this.querySelectorAll('[data-fbt-total]'));
    this.compareEls = Array.from(this.querySelectorAll('[data-fbt-compare]'));
    this.savingsEls = Array.from(this.querySelectorAll('[data-fbt-savings]'));
    this.compareWraps = Array.from(this.querySelectorAll('.fbt__summary-compare'));

    this._mobileMediaQuery = window.matchMedia('(max-width: 699px)');
    this._onVariantChange = this._onVariantChange.bind(this);
    this._onToggle = this._onToggle.bind(this);
    this._onAdd = this._onAdd.bind(this);
    this._onCardClick = this._onCardClick.bind(this);

    document.addEventListener('variant:change', this._onVariantChange);
    this.toggles.forEach((input) => input.addEventListener('change', this._onToggle));
    this.addButtons.forEach((button) => button.addEventListener('click', this._onAdd));
    this.addEventListener('click', this._onCardClick);

    // The server already renders the correct default-variant image, price and
    // totals, so only keep the totals in sync here (avoids a redundant image fetch).
    this._renderTotals();
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this._onVariantChange);
    this.toggles?.forEach((input) => input.removeEventListener('change', this._onToggle));
    this.addButtons?.forEach((button) => button.removeEventListener('click', this._onAdd));
    this.removeEventListener('click', this._onCardClick);
  }

  _parseData() {
    try {
      return JSON.parse(this.querySelector('[data-fbt-json]').textContent);
    } catch (error) {
      console.warn('BBBundle: invalid data', error);
      return null;
    }
  }

  _stateKey() {
    if (!this.toggles.length) return this.data.stateKeys[0];
    return this.toggles.map((input) => (input.checked ? '1' : '0')).join('');
  }

  _onVariantChange(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;
    const id = String(variant.id);
    if (!this.data.variants[id]) return;
    this.selectedVariant = id;
    this._render();
  }

  _onToggle(event) {
    const index = event.target.dataset.addonIndex;
    const checked = event.target.checked;
    this.querySelector(`[data-addon-item="${index}"]`)?.classList.toggle('is-unchecked', !checked);
    const tile = this.querySelector(`[data-addon-tile="${index}"]`);
    if (tile) {
      tile.classList.toggle('is-removed', !checked);
      tile.previousElementSibling?.classList.toggle('is-removed', !checked);
    }
    this._renderTotals();
  }

  _onCardClick(event) {
    if (!this._mobileMediaQuery.matches) return;
    if (event.target.closest('input, label, a, button')) return;
    const checkbox = event.target.closest('.fbt__item--addon')?.querySelector('[data-fbt-toggle]');
    if (!checkbox) return;
    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  _render() {
    this._renderVariant();
    this._renderTotals();
  }

  _renderVariant() {
    const variant = this.data.variants[this.selectedVariant];
    if (!variant) return;
    if (variant.image) {
      this.anchorImages.forEach((img) => {
        img.src = variant.image;
        img.removeAttribute('srcset');
      });
    }
    this.anchorPrices.forEach((el) => (el.textContent = variant.price));
  }

  _renderTotals() {
    const variant = this.data.variants[this.selectedVariant];
    if (!variant) return;
    const stateKey = this._stateKey();
    const savings = this.data.savings[stateKey] || '';
    const hasSavings = savings !== '';

    this.totalEls.forEach((el) => (el.textContent = variant.total[stateKey]));
    this.compareEls.forEach((el) => (el.textContent = variant.compare[stateKey]));
    this.savingsEls.forEach((el) => {
      el.textContent = this.savingsTemplate.replace('{amount}', savings);
      el.toggleAttribute('hidden', !hasSavings);
    });
    this.compareWraps.forEach((el) => el.toggleAttribute('hidden', !hasSavings));
  }

  _collectItems() {
    const parentId = Number(this.selectedVariant);
    const items = [{ id: parentId, quantity: 1 }];
    this.toggles.forEach((input) => {
      if (!input.checked) return;
      items.push({
        id: Number(input.dataset.variantId),
        quantity: 1,
        parent_id: parentId
      });
    });
    return items;
  }

  async _onAdd() {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const settings = (window.themeVariables && window.themeVariables.settings) || {};

    this.addButtons.forEach((button) => button.setAttribute('aria-busy', 'true'));

    // Let the cart drawer / notification register which sections must be re-rendered.
    const sections = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
    );

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: this._collectItems(),
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });
      const responseJson = await response.json();

      if (!response.ok) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      if (settings.cartType === 'page' || settings.pageType === 'cart') {
        window.location.href = `${root}cart`;
        return;
      }

      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = responseJson.sections;

      this.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: { items: responseJson.items || [responseJson], cart }
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart }
        })
      );
    } catch (error) {
      console.warn('BBBundle: add to cart failed', error);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      this.addButtons.forEach((button) => button.removeAttribute('aria-busy'));
    }
  }
}

if (!customElements.get('bb-bundle')) {
  customElements.define('bb-bundle', BBBundle);
}

/* Header menus with trigger="hover" navigate to data-url on click, which also
   swallows the Enter key. Toggle the disclosure instead so mega menus stay
   keyboard accessible (Space already toggles natively). Facelift header only. */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;

  const summary = event.target instanceof Element ? event.target.closest('.header--facelift .header__link-list summary') : null;
  if (!summary) return;

  const details = summary.closest('details');

  if (details && details.getAttribute('trigger') === 'hover') {
    event.preventDefault();
    details.open = !details.open;
  }
});
